import script from "./DanhSachCongTy.vue?vue&type=script&setup=true&lang=js"
export * from "./DanhSachCongTy.vue?vue&type=script&setup=true&lang=js"

import "./DanhSachCongTy.vue?vue&type=style&index=0&id=d170a886&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d170a886"]])

export default __exports__